<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import SaintModal from "./SaintModal.vue"
import SaintEditModal from "./SaintEditModal.vue"
import SaintsTable from "./SaintsTable.vue"
import SaintViewModal from "./SaintViewModal.vue"

const title = "مدیریت قدیس های روزانه"
const pageTitle = "داشبورد"

const DEFAULT_SAINT = {
  id: "",
  title: "",
  text: "",
  date: "",
}

const saintModel = ref({ ...DEFAULT_SAINT })
const showSaintModal = ref(false)
const showSaintEditModal = ref(false)
const showSaintViewModal = ref(false)

const showAddNewModal = () => {
  showSaintModal.value = true
}

const showEditModal = () => {
  showSaintEditModal.value = true
}

const showViewModal = () => {
  showSaintViewModal.value = true
}

const editSaint = (saint) => {
  saintModel.value = saint
  showEditModal()
}

const viewSaint = (saint) => {
  saintModel.value = saint
  showViewModal()
}

const onModalClose = () => {
  saintModel.value = { ...DEFAULT_SAINT }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :pageTitle="pageTitle" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="saintList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست قدیس های روزانه</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>افزودن قدیس
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- saints table  -->

          <SaintsTable @clickEdit="editSaint" @clickView="viewSaint" />

          <!-- add and edit saint modal  -->

          <SaintModal
            v-model="showSaintModal"
            :saint="saintModel"
            @close="onModalClose"
          />

          <SaintViewModal
            v-model="showSaintViewModal"
            :saint="saintModel"
            @close="onModalClose"
          />

          <SaintEditModal
            v-model="showSaintEditModal"
            :saint="saintModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
